import EntityService from "./entity";

class UserService extends EntityService {
  constructor(name) {
    super(name)
  }
}
export default new UserService("user")



// WEBPACK FOOTER //
// ./src/services/user.js